/**
 * Builds a domain URL based on environment stage
 * Following the established pattern from deployment/src/create-service-task.ts
 *
 * @param options - Configuration object for domain building
 * @param options.environmentStage - The environment stage (production, staging, sandbox, demo, preview, dev-*, etc.)
 * @param options.subdomain - Optional subdomain to prepend (e.g., "api", "internal-api")
 * @param options.useDevEnvNames - Whether to use dev environment names or treat dev-* as staging (defaults to true)
 * @returns The full domain URL
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get buildDomainUrl () {
        return buildDomainUrl;
    },
    get buildUrl () {
        return buildUrl;
    }
});
const buildDomainUrl = (options = {})=>{
    const { environmentStage, subdomain, useDevEnvNames = true } = options;
    let domain;
    if (!environmentStage || environmentStage === "other") {
        domain = "staging.talent.performyard.com";
    } else if (environmentStage === "local" || environmentStage === "localhost") {
        return "localhost:8888";
    } else if (environmentStage.startsWith("dev-")) {
        if (useDevEnvNames) {
            const devEnvironment = environmentStage.replace("dev-", "");
            domain = `${devEnvironment}.staging.performyard.com`;
        } else {
            domain = "staging.talent.performyard.com";
        }
    } else if (environmentStage === "production") {
        domain = "talent.performyard.com";
    } else if ([
        "staging",
        "sandbox",
        "demo",
        "preview"
    ].includes(environmentStage)) {
        domain = `${environmentStage}.talent.performyard.com`;
    } else {
        // Default fallback for other environments
        domain = `${environmentStage}.staging.performyard.com`;
    }
    if (subdomain) {
        return `${subdomain}.${domain}`;
    }
    return domain;
};
const buildUrl = (options = {})=>{
    const { environmentStage, subdomain, path, protocol } = options;
    // Determine the protocol - use http for local environments unless explicitly overridden
    const finalProtocol = protocol || (environmentStage === "local" || environmentStage === "localhost" ? "http" : "https");
    const domain = buildDomainUrl({
        environmentStage,
        subdomain
    });
    const basePath = path || "";
    return `${finalProtocol}://${domain}${basePath}`;
};
